// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"Menu_menuWrapper__9eM1m","overlay":"Menu_overlay__Dt5Is","menu":"Menu_menu__3QBKw","item":"Menu_item__1j28B","itemLink":"Menu_itemLink__2V9Am"};